
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 34"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 26.254c-.31 0-.615.09-.873.26s-.46.411-.579.693a1.52 1.52 0 00.34 1.683 1.598 1.598 0 001.713.335c.288-.117.533-.315.706-.569a1.525 1.525 0 00-.196-1.95A1.585 1.585 0 0011 26.254zM20.429 0H1.57C1.155 0 .755.163.461.452.165.742 0 1.135 0 1.544v13.9c0 1.228.497 2.407 1.38 3.275a4.756 4.756 0 003.334 1.357h1.572v3.66a6.132 6.132 0 00-1.502 3.167 6.081 6.081 0 00.487 3.461 6.21 6.21 0 002.32 2.648C8.605 33.657 9.79 34 11 34c1.21 0 2.394-.343 3.41-.988a6.21 6.21 0 002.319-2.648 6.081 6.081 0 00.487-3.46 6.132 6.132 0 00-1.502-3.167v-3.66h1.572c1.25 0 2.45-.489 3.333-1.358A4.593 4.593 0 0022 15.444V1.545c0-.41-.166-.802-.46-1.092A1.585 1.585 0 0020.429 0zM11 30.887a3.181 3.181 0 01-1.768-.551A3.098 3.098 0 018.088 28.9a3.038 3.038 0 01-.121-1.819 3.079 3.079 0 01.943-1.57 1.545 1.545 0 00.519-1.142v-4.294h3.142v4.294a1.522 1.522 0 00.519 1.143c.468.418.797.965.943 1.57a3.038 3.038 0 01-.121 1.818 3.097 3.097 0 01-1.144 1.435 3.181 3.181 0 01-1.768.551zm7.857-15.444c0 .41-.165.803-.46 1.092-.295.29-.694.453-1.111.453H4.714c-.416 0-.816-.163-1.11-.453a1.53 1.53 0 01-.461-1.091v-1.545h15.714v1.545zm0-4.633H3.143V3.09h15.714v7.721z"}})])
          )
        }
      }
    